import type { FC } from "react";

import dayjs from "dayjs";
import _ from "lodash";

import { minVisitsAbbrFilter } from "app/filters/ngFilters";

import Chart from "../../Chart";
import { ChartContainer, ChartLegendContainer } from "../PeriodOverPeriodChart/StyledComponents";
import { getPeriodConfig, getWebsiteConfig } from "../PopWithComapreChart/chartConfig";
interface IPoPWithCompareGraphProps {
    type?: string;
    data: FixmeType;
    view: string;
    xAxisFormatter?: ({ value }: { value: FixmeType }) => string;
    yAxisFormatter?: ({ value }: { value: FixmeType }) => string;
    legendDurations?: string[];
    options?: {
        stackedColumn?: boolean;
        categoryXSeries?: boolean;
        height?: number;
    };
}
const defaultXAxisFormatter = ({ value }: { value: FixmeType }) =>
    value ? dayjs.utc(value).utc().format("MMM") : "N/A";
const categoryXAxisFormatter = ({ value }: { value: FixmeType }) => value;

export const PoPWithCompareChart: FC<IPoPWithCompareGraphProps> = ({
    type = "column",
    data,
    xAxisFormatter,
    yAxisFormatter = ({ value }: { value: FixmeType }) => (_.isNumber(value) ? minVisitsAbbrFilter()(value) : "N/A"),
    legendDurations,
    options = { stackedColumn: false, categoryXSeries: false },
    view,
}) => {
    const selectedXAxisFormatter =
        xAxisFormatter || options.categoryXSeries ? categoryXAxisFormatter : defaultXAxisFormatter;
    const isStackedColumn = false;
    const configParams = {
        type,
        xAxisFormatter: selectedXAxisFormatter,
        yAxisFormatter,
        isStackedColumn,
        categoryXSeries: options.categoryXSeries,
        legendDurations,
        height: options.height,
        data,
    };
    const config = view === "website" ? getWebsiteConfig(configParams) : getPeriodConfig(configParams);

    return (
        <div>
            <ChartLegendContainer>
                <ChartContainer className={"chartContainer"}>
                    <Chart
                        key={`PoPWithCompareChart-${view}`}
                        type={type}
                        data={data}
                        config={config}
                    />
                </ChartContainer>
            </ChartLegendContainer>
        </div>
    );
};
PoPWithCompareChart.displayName = "PoPWithCompareGraph";
